let robotsConstant =   [
  {
    lable: "index, follow",
    value: "1",
  },
  {
    lable: "noindex, follow",
    value: "2",
  },
  {
    lable: "index, nofollow",
    value: "3",
  },
  {
    lable: "noindex, nofollow",
    value: "4",
  },
  ];
  
  export default robotsConstant